/**
 * This file contains all the constants necessary for Shared Storage
 */

export const PREFIX = 'sessionAccessId-';
